import {
  boolean,
  pgSchema,
  text,
  timestamp,
  varchar,
} from "drizzle-orm/pg-core"
import { ulidId } from "./shared"

export const announcementSchema = pgSchema("announcement")

export const announcement = announcementSchema.table("announcement", {
  id: ulidId(), // prefix: ann-
  title: text("title").notNull(),
  message: text("message").notNull(),
  publishDate: timestamp("publish_date", { withTimezone: true }).notNull(),
  endDate: timestamp("end_date", { withTimezone: true }).notNull(),
  active: boolean("active").notNull().default(true),
  createdAt: timestamp("created_at", { withTimezone: true })
    .defaultNow()
    .notNull(),
  createdBy: varchar("created_by", { length: 255 }).notNull(),
})
